import { Link } from "react-router-dom";

import Footer from "@/components/Footer";
import SharedHeader from "@/components/SharedHeader";
import { theme } from "@/lib/theme";
import { cn } from "@/lib/utils";

export default function NotFoundPage() {
  return (
    <div className={cn("min-h-screen flex flex-col", theme.colors.backgroundCream)}>
      <SharedHeader />
      <main className="flex-1 pt-28 pb-16">
        <div className="mx-auto max-w-4xl px-6">
          <section className={cn("p-8 md:p-12 rounded-2xl", theme.cards.base)}>
            <p className="text-sm font-semibold uppercase tracking-wide text-gray-600 dark:text-gray-300">
              404
            </p>
            <h1 className="mt-3 text-3xl md:text-5xl font-black text-gray-900 dark:text-white">
              Page not found
            </h1>
            <p className="mt-4 text-lg text-gray-700 dark:text-gray-300">
              We couldn&apos;t find that page. Try one of the links below.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <Link to="/" className={cn(theme.buttons.primary, "px-6 py-3 font-semibold")}>Back to home</Link>
              <Link to="/pricing" className={cn(theme.buttons.secondary, "px-6 py-3 font-semibold")}>View pricing</Link>
              <Link to="/faq" className={cn(theme.buttons.secondary, "px-6 py-3 font-semibold")}>Read FAQs</Link>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
